export const SET_INITIALIZED = 'SET_INITIALIZED';
export const SET_ONBOARDING = 'SET_ONBOARDING';
export const SET_LOADING = 'SET_LOADING';
export const CLEAR_STORAGE = 'CLEAR_STORAGE';
export const SET_CALLBACK_LINK = 'SET_CALLBACK_LINK';
